export const validateRefregdSchema = json => {
    return true;
};
